// extracted by mini-css-extract-plugin
export var officesItem = "Offices-module--officesItem--MqMIR";
export var officeImage = "Offices-module--officeImage--3E3dl";
export var content = "Offices-module--content--1K2jj";
export var moreInfoCard = "Offices-module--moreInfoCard--1ZRp9";